(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

// --- 1. Inject CSS from JavaScript ---
const style = document.createElement("style");
style.innerHTML = `
  .menu-list__submenu {
    display: none !important;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s ease;
  }
  .menu-list__submenu.active {
    display: block !important;
    opacity: 1;
    visibility: visible;
  }
`;
document.head.appendChild(style);

// --- 2. Select "Shop" menu item + submenu ---
const shopMenu = document.querySelector('.menu-list__link[href="/collections/all"]');
const submenu = shopMenu?.parentElement.querySelector('.menu-list__submenu');

// --- 3. Add JS-based hover behavior ---
if (shopMenu && submenu) {

  // Show submenu on hover
  shopMenu.addEventListener("mouseenter", () => {
    submenu.classList.add("active");
  });

  // Keep submenu visible when mouse enters the submenu area
  submenu.addEventListener("mouseenter", () => {
    submenu.classList.add("active");
  });

  // Hide submenu when leaving both menu + submenu
  shopMenu.addEventListener("mouseleave", () => {
    setTimeout(() => {
      if (!submenu.matches(':hover')) submenu.classList.remove("active");
    }, 150);
  });

  submenu.addEventListener("mouseleave", () => {
    submenu.classList.remove("active");
  });
}
